import React from "react";
import Grid from "@mui/material/Grid";
import { feedbackHead } from "./FeedBackData";

function FeedBackHeader(props) {
  const data = feedbackHead(props?.tableData);
  const onRating = (rating) => {
    props?.onRating(rating);
  };
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        className="marginBottom7"
      >
        {data?.map((ele, id) => (
          <Grid
            item
            xs={2.2}
            key={ele.id}
            className={`cursor ${
              props?.statusCard === ele?.rating
                ? "activeFeedbackCardRating"
                : "feedbackCardRating"
            }`}
            onClick={() => onRating(ele?.rating)}
          >
            <Grid item container direction="row" alignItems="center">
              <img src={ele.image} alt="star" className="width30" />
              <h1 className="fontSemi font16 marginInline10">
                {ele.ratingName}
              </h1>
            </Grid>
            <Grid item>
              <p className="marginBottom7 marginTop font24 fontSemi">
                {ele.totalrating}
              </p>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default FeedBackHeader;
